import { Platform, PlatformEnvironment, VMType } from "./enums.js";
import { Currency } from "./models/financial/currency.js";
export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
export const ONE_ADDRESS = "0x0000000000000000000000000000000000000001";
export const TWO_ADDRESS = "0x0000000000000000000000000000000000000002";
export const NATIVE_TOKEN_ADDRESS = ZERO_ADDRESS;
export const TWO_TO_THE_POWER_246 = BigInt("115792089237316195423570985008687907853269984665640564039457574007913129639935");
// Fiat Currencies - all use 6 decimals for consistency with crypto precision
export const USDC_CURRENCY = new Currency(6, "USDC", "USD Coin", undefined, false, false, "usd-coin", true);
export const USD_CURRENCY = new Currency(6, "USD", "US Dollar", undefined, false, false, "usd-coin", true);
export const EUR_CURRENCY = new Currency(6, "EUR", "Euro", undefined, false, false);
export const GBP_CURRENCY = new Currency(6, "GBP", "British Pound", undefined, false, false);
export const CAD_CURRENCY = new Currency(6, "CAD", "Canadian Dollar", undefined, false, false);
export const BRL_CURRENCY = new Currency(6, "BRL", "Brazilian Real", undefined, false, false);
export const MXN_CURRENCY = new Currency(6, "MXN", "Mexican Peso", undefined, false, false);
// African Currencies
export const NGN_CURRENCY = new Currency(6, "NGN", "Nigerian Naira", undefined, false, false);
export const GHS_CURRENCY = new Currency(6, "GHS", "Ghanaian Cedi", undefined, false, false);
export const KES_CURRENCY = new Currency(6, "KES", "Kenyan Shilling", undefined, false, false);
export const ZAR_CURRENCY = new Currency(6, "ZAR", "South African Rand", undefined, false, false);
export const UGX_CURRENCY = new Currency(6, "UGX", "Ugandan Shilling", undefined, false, false);
export const TZS_CURRENCY = new Currency(6, "TZS", "Tanzanian Shilling", undefined, false, false);
export const RWF_CURRENCY = new Currency(6, "RWF", "Rwandan Franc", undefined, false, false);
export const ZMW_CURRENCY = new Currency(6, "ZMW", "Zambian Kwacha", undefined, false, false);
export const BWP_CURRENCY = new Currency(6, "BWP", "Botswanan Pula", undefined, false, false);
export const XAF_CURRENCY = new Currency(6, "XAF", "Central African CFA Franc", undefined, false, false);
export const XOF_CURRENCY = new Currency(6, "XOF", "West African CFA Franc", undefined, false, false);
export const FIAT_CURRENCY = USD_CURRENCY;
export const PLATFORM_ID = {
    [Platform.ETHEREUM]: 1,
    [Platform.POLYGON]: 137,
    [Platform.BINANCE]: 56,
    [Platform.ARBITRUM]: 42161,
    [Platform.ARBITRUM_NOVA]: 42170,
    [Platform.OPTIMISM]: 10,
    [Platform.EVMOS]: 9001,
    [Platform.MOONBEAM]: 1284,
    [Platform.BASE]: 8453,
    [Platform.AVALANCHE]: 43114,
    [Platform.SOLANA]: 101,
    [Platform.SONIC]: 146,
    [Platform.MANTLE]: 5000,
    // testnets
    [Platform.ETHEREUM_SEPOLIA]: 11155111,
    [Platform.ETHEREUM_HOLESKY]: 17000,
    [Platform.ARBITRUM_SEPOLIA]: 421614,
    [Platform.OPTIMISM_SEPOLIA]: 11155420,
    [Platform.POLYGON_AMOY]: 80002,
    [Platform.BINANCE_TESTNET]: 97,
    [Platform.OPBNB_TESTNET]: 5611,
    [Platform.MOONBEAM_ALPHA]: 1287,
    [Platform.BASE_SEPOLIA]: 84532,
    [Platform.SONIC_BLAZE]: 57054,
    [Platform.MANTLE_SEPOLIA]: 5003,
    // OFFCHAIN
    [Platform.OKX]: 1000,
    [Platform.COINBASE]: 1001,
    [Platform.KRAKEN]: 1002,
    [Platform.GEMINI]: 1003,
    [Platform.HYPERLIQUID_PLATFORM]: 2000,
    [Platform.HYPEREVM]: 999,
    [Platform.STRIPE]: 1_000_000_000_000_000,
    [Platform.CROSSMINT]: 1_000_000_000_000_001,
    [Platform.COINBASE_ONRAMP]: 1_000_000_000_000_002,
    [Platform.MOONPAY]: 1_000_000_000_000_003,
    [Platform.YELLOWCARD]: 1_000_000_000_000_004,
    [Platform.LEKKA_CASH]: 1_000_000_000_000_005,
    [Platform.TURNKEY]: 1_000_000_000_000_006,
    [Platform.MESH_CONNECT]: 1_000_000_000_000_007,
    [Platform.POLYMARKET]: 1_000_000_000_000_008,
    [Platform.RAMP_NETWORK]: 1_000_000_000_000_009,
    // local testing
    [Platform.HARDHAT]: 31337,
    [Platform.LOCAL_CHAIN_0]: 1_000_000_000_001,
    [Platform.LOCAL_CHAIN_1]: 1_000_000_000_002,
};
export const PLATFORM_ID_TO_ENUM = {
    1: Platform.ETHEREUM,
    137: Platform.POLYGON,
    56: Platform.BINANCE,
    42161: Platform.ARBITRUM,
    42170: Platform.ARBITRUM_NOVA,
    10: Platform.OPTIMISM,
    9001: Platform.EVMOS,
    1284: Platform.MOONBEAM,
    8453: Platform.BASE,
    43114: Platform.AVALANCHE,
    101: Platform.SOLANA,
    146: Platform.SONIC,
    5000: Platform.MANTLE,
    // testnets
    11155111: Platform.ETHEREUM_SEPOLIA,
    84532: Platform.BASE_SEPOLIA,
    17000: Platform.ETHEREUM_HOLESKY,
    421614: Platform.ARBITRUM_SEPOLIA,
    11155420: Platform.OPTIMISM_SEPOLIA,
    80002: Platform.POLYGON_AMOY,
    97: Platform.BINANCE_TESTNET,
    5611: Platform.OPBNB_TESTNET,
    1287: Platform.MOONBEAM_ALPHA,
    57054: Platform.SONIC_BLAZE,
    5003: Platform.MANTLE_SEPOLIA,
    // OFFCHAIN
    1000: Platform.OKX,
    1001: Platform.COINBASE,
    1002: Platform.KRAKEN,
    1003: Platform.GEMINI,
    2000: Platform.HYPERLIQUID_PLATFORM,
    999: Platform.HYPEREVM,
    1_000_000_000_000_000: Platform.STRIPE,
    1_000_000_000_000_001: Platform.CROSSMINT,
    1_000_000_000_000_002: Platform.COINBASE_ONRAMP,
    1_000_000_000_000_003: Platform.MOONPAY,
    1_000_000_000_000_004: Platform.YELLOWCARD,
    1_000_000_000_000_005: Platform.LEKKA_CASH,
    1_000_000_000_000_006: Platform.TURNKEY,
    1_000_000_000_000_007: Platform.MESH_CONNECT,
    1_000_000_000_000_008: Platform.POLYMARKET,
    1_000_000_000_000_009: Platform.RAMP_NETWORK,
    // local testing
    31337: Platform.HARDHAT,
    1_000_000_000_001: Platform.LOCAL_CHAIN_0,
    1_000_000_000_002: Platform.LOCAL_CHAIN_1,
};
export const PLATFORM_NAME_TO_ENUM = {
    ETHEREUM: Platform.ETHEREUM,
    POLYGON: Platform.POLYGON,
    BINANCE: Platform.BINANCE,
    ARBITRUM: Platform.ARBITRUM,
    ARBITRUM_NOVA: Platform.ARBITRUM_NOVA,
    OPTIMISM: Platform.OPTIMISM,
    EVMOS: Platform.EVMOS,
    MOONBEAM: Platform.MOONBEAM,
    BASE: Platform.BASE,
    AVALANCHE: Platform.AVALANCHE,
    SOLANA: Platform.SOLANA,
    SONIC: Platform.SONIC,
    MANTLE: Platform.MANTLE,
    // testnets
    ETHEREUM_SEPOLIA: Platform.ETHEREUM_SEPOLIA,
    ETHEREUM_HOLESKY: Platform.ETHEREUM_HOLESKY,
    ARBITRUM_SEPOLIA: Platform.ARBITRUM_SEPOLIA,
    BASE_SEPOLIA: Platform.BASE_SEPOLIA,
    OPTIMISM_SEPOLIA: Platform.OPTIMISM_SEPOLIA,
    POLYGON_AMOY: Platform.POLYGON_AMOY,
    BINANCE_TESTNET: Platform.BINANCE_TESTNET,
    OPBNB_TESTNET: Platform.OPBNB_TESTNET,
    MOONBEAM_ALPHA: Platform.MOONBEAM_ALPHA,
    SONIC_BLAZE: Platform.SONIC_BLAZE,
    MANTLE_SEPOLIA: Platform.MANTLE_SEPOLIA,
    // OFFCHAIN
    STRIPE: Platform.STRIPE,
    CROSSMINT: Platform.CROSSMINT,
    COINBASE_ONRAMP: Platform.COINBASE_ONRAMP,
    MOONPAY: Platform.MOONPAY,
    YELLOWCARD: Platform.YELLOWCARD,
    LEKKA_CASH: Platform.LEKKA_CASH,
    OKX: Platform.OKX,
    COINBASE: Platform.COINBASE,
    KRAKEN: Platform.KRAKEN,
    GEMINI: Platform.GEMINI,
    TURNKEY: Platform.TURNKEY,
    MESH_CONNECT: Platform.MESH_CONNECT,
    POLYMARKET: Platform.POLYMARKET,
    RAMP_NETWORK: Platform.RAMP_NETWORK,
    // local testing
    HARDHAT: Platform.HARDHAT,
    LOCAL_CHAIN_0: Platform.LOCAL_CHAIN_0,
    LOCAL_CHAIN_1: Platform.LOCAL_CHAIN_1,
};
/**
 * Platform configurations with essential chain metadata (no viem dependencies)
 */
export const PLATFORM_CONFIGS = {
    // Mainnets
    [Platform.ETHEREUM]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
        nativeTokenCoingeckoId: "ethereum",
    },
    [Platform.POLYGON]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "Polygon Token", symbol: "POL", decimals: 18 },
        nativeTokenCoingeckoId: "polygon-ecosystem-token",
    },
    [Platform.BINANCE]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
        nativeTokenCoingeckoId: "binancecoin",
    },
    [Platform.ARBITRUM]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
        nativeTokenCoingeckoId: "ethereum",
    },
    [Platform.ARBITRUM_NOVA]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
        nativeTokenCoingeckoId: "ethereum",
    },
    [Platform.OPTIMISM]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
        nativeTokenCoingeckoId: "ethereum",
    },
    [Platform.EVMOS]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "Evmos", symbol: "EVMOS", decimals: 18 },
        nativeTokenCoingeckoId: "evmos",
    },
    [Platform.MOONBEAM]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "GLMR", symbol: "GLMR", decimals: 18 },
        nativeTokenCoingeckoId: "moonbeam",
    },
    [Platform.BASE]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
        nativeTokenCoingeckoId: "ethereum",
    },
    [Platform.AVALANCHE]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "Avalanche", symbol: "AVAX", decimals: 18 },
        nativeTokenCoingeckoId: "avalanche-2",
    },
    [Platform.SOLANA]: {
        vmType: VMType.SVM,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "Solana", symbol: "SOL", decimals: 9 },
        nativeTokenCoingeckoId: "solana",
    },
    [Platform.SONIC]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "Sonic", symbol: "S", decimals: 18 },
        nativeTokenCoingeckoId: "sonic-3",
    },
    [Platform.MANTLE]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "Mantle", symbol: "MNT", decimals: 18 },
        nativeTokenCoingeckoId: "mantle",
    },
    // Testnets
    [Platform.ETHEREUM_SEPOLIA]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.TESTNET,
        nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
        nativeTokenCoingeckoId: "ethereum",
    },
    [Platform.ETHEREUM_HOLESKY]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.TESTNET,
        nativeCurrency: { name: "Holesky Ether", symbol: "ETH", decimals: 18 },
        nativeTokenCoingeckoId: "ethereum",
    },
    [Platform.ARBITRUM_SEPOLIA]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.TESTNET,
        nativeCurrency: { name: "Arbitrum Sepolia Ether", symbol: "ETH", decimals: 18 },
        nativeTokenCoingeckoId: "ethereum",
    },
    [Platform.BASE_SEPOLIA]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.TESTNET,
        nativeCurrency: { name: "Base Sepolia Ether", symbol: "ETH", decimals: 18 },
        nativeTokenCoingeckoId: "ethereum",
    },
    [Platform.OPTIMISM_SEPOLIA]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.TESTNET,
        nativeCurrency: { name: "Optimism Sepolia Ether", symbol: "ETH", decimals: 18 },
        nativeTokenCoingeckoId: "ethereum",
    },
    [Platform.POLYGON_AMOY]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.TESTNET,
        nativeCurrency: { name: "Polygon Token", symbol: "POL", decimals: 18 },
        nativeTokenCoingeckoId: "polygon-ecosystem-token",
    },
    [Platform.BINANCE_TESTNET]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.TESTNET,
        nativeCurrency: { name: "BNB", symbol: "tBNB", decimals: 18 },
        nativeTokenCoingeckoId: "binancecoin",
    },
    [Platform.OPBNB_TESTNET]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.TESTNET,
        nativeCurrency: { name: "BNB", symbol: "tBNB", decimals: 18 },
        nativeTokenCoingeckoId: "binancecoin",
    },
    [Platform.MOONBEAM_ALPHA]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.TESTNET,
        nativeCurrency: { name: "DEV", symbol: "DEV", decimals: 18 },
        nativeTokenCoingeckoId: "moonbeam",
    },
    [Platform.SONIC_BLAZE]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.TESTNET,
        nativeCurrency: { name: "Sonic", symbol: "S", decimals: 18 },
        nativeTokenCoingeckoId: "sonic-3",
    },
    [Platform.MANTLE_SEPOLIA]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.TESTNET,
        nativeCurrency: { name: "Mantle", symbol: "MNT", decimals: 18 },
        nativeTokenCoingeckoId: "mantle",
    },
    // Local testing
    [Platform.HARDHAT]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.TESTNET,
        nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
        nativeTokenCoingeckoId: "ethereum",
    },
    [Platform.LOCAL_CHAIN_0]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.TESTNET,
        nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
        nativeTokenCoingeckoId: "ethereum",
    },
    [Platform.LOCAL_CHAIN_1]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.TESTNET,
        nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
        nativeTokenCoingeckoId: "ethereum",
    },
    // Offchain platforms
    [Platform.OKX]: {
        vmType: VMType.OFFCHAIN,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "USD", symbol: "USD", decimals: 6 },
        nativeTokenCoingeckoId: "usd-coin",
    },
    [Platform.COINBASE]: {
        vmType: VMType.OFFCHAIN,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "USD", symbol: "USD", decimals: 6 },
        nativeTokenCoingeckoId: "usd-coin",
    },
    [Platform.KRAKEN]: {
        vmType: VMType.OFFCHAIN,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "USD", symbol: "USD", decimals: 6 },
        nativeTokenCoingeckoId: "usd-coin",
    },
    [Platform.GEMINI]: {
        vmType: VMType.OFFCHAIN,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "USD", symbol: "USD", decimals: 6 },
        nativeTokenCoingeckoId: "usd-coin",
    },
    [Platform.STRIPE]: {
        vmType: VMType.OFFCHAIN,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "USD", symbol: "USD", decimals: 6 },
        nativeTokenCoingeckoId: "usd-coin",
    },
    [Platform.CROSSMINT]: {
        vmType: VMType.OFFCHAIN,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "USD", symbol: "USD", decimals: 6 },
        nativeTokenCoingeckoId: "",
    },
    [Platform.COINBASE_ONRAMP]: {
        vmType: VMType.OFFCHAIN,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "USD", symbol: "USD", decimals: 6 },
        nativeTokenCoingeckoId: "usd-coin",
    },
    [Platform.MOONPAY]: {
        vmType: VMType.OFFCHAIN,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "USD", symbol: "USD", decimals: 6 },
        nativeTokenCoingeckoId: "usd-coin",
    },
    [Platform.YELLOWCARD]: {
        vmType: VMType.OFFCHAIN,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "USD", symbol: "USD", decimals: 6 },
        nativeTokenCoingeckoId: "usd-coin",
    },
    [Platform.LEKKA_CASH]: {
        vmType: VMType.OFFCHAIN,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "USD", symbol: "USD", decimals: 6 },
        nativeTokenCoingeckoId: "usd-coin",
    },
    [Platform.HYPERLIQUID_PLATFORM]: {
        vmType: VMType.OFFCHAIN,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "USD Coin", symbol: "USDC", decimals: 8 },
        nativeTokenCoingeckoId: "usd-coin",
    },
    [Platform.HYPEREVM]: {
        vmType: VMType.EVM,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "HYPE", symbol: "HYPE", decimals: 18 },
        nativeTokenCoingeckoId: "hyperliquid",
    },
    [Platform.TURNKEY]: {
        vmType: VMType.OFFCHAIN,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "USD", symbol: "USD", decimals: 6 },
        nativeTokenCoingeckoId: "usd-coin",
    },
    [Platform.MESH_CONNECT]: {
        vmType: VMType.OFFCHAIN,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "USD Coin", symbol: "USDC", decimals: 6 },
        nativeTokenCoingeckoId: "usd-coin",
    },
    [Platform.POLYMARKET]: {
        vmType: VMType.OFFCHAIN,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "USD", symbol: "USD", decimals: 6 },
        nativeTokenCoingeckoId: "usd-coin",
    },
    [Platform.RAMP_NETWORK]: {
        vmType: VMType.OFFCHAIN,
        environment: PlatformEnvironment.MAINNET,
        nativeCurrency: { name: "USD", symbol: "USD", decimals: 6 },
        nativeTokenCoingeckoId: "usd-coin",
    },
};
export const COUNTRIES = [
    { code: "AF", name: "Afghanistan", dialCode: "+93", flag: "🇦🇫" },
    { code: "AL", name: "Albania", dialCode: "+355", flag: "🇦🇱" },
    { code: "DZ", name: "Algeria", dialCode: "+213", flag: "🇩🇿" },
    { code: "AS", name: "American Samoa", dialCode: "+1684", flag: "🇦🇸" },
    { code: "AD", name: "Andorra", dialCode: "+376", flag: "🇦🇩" },
    { code: "AO", name: "Angola", dialCode: "+244", flag: "🇦🇴" },
    { code: "AI", name: "Anguilla", dialCode: "+1264", flag: "🇦🇮" },
    { code: "AG", name: "Antigua and Barbuda", dialCode: "+1268", flag: "🇦🇬" },
    { code: "AR", name: "Argentina", dialCode: "+54", flag: "🇦🇷" },
    { code: "AM", name: "Armenia", dialCode: "+374", flag: "🇦🇲" },
    { code: "AW", name: "Aruba", dialCode: "+297", flag: "🇦🇼" },
    { code: "AU", name: "Australia", dialCode: "+61", flag: "🇦🇺" },
    { code: "AT", name: "Austria", dialCode: "+43", flag: "🇦🇹" },
    { code: "AZ", name: "Azerbaijan", dialCode: "+994", flag: "🇦🇿" },
    { code: "BS", name: "Bahamas", dialCode: "+1242", flag: "🇧🇸" },
    { code: "BH", name: "Bahrain", dialCode: "+973", flag: "🇧🇭" },
    { code: "BD", name: "Bangladesh", dialCode: "+880", flag: "🇧🇩" },
    { code: "BB", name: "Barbados", dialCode: "+1246", flag: "🇧🇧" },
    { code: "BY", name: "Belarus", dialCode: "+375", flag: "🇧🇾" },
    { code: "BE", name: "Belgium", dialCode: "+32", flag: "🇧🇪" },
    { code: "BZ", name: "Belize", dialCode: "+501", flag: "🇧🇿" },
    { code: "BJ", name: "Benin", dialCode: "+229", flag: "🇧🇯" },
    { code: "BM", name: "Bermuda", dialCode: "+1441", flag: "🇧🇲" },
    { code: "BT", name: "Bhutan", dialCode: "+975", flag: "🇧🇹" },
    { code: "BO", name: "Bolivia", dialCode: "+591", flag: "🇧🇴" },
    { code: "BA", name: "Bosnia and Herzegovina", dialCode: "+387", flag: "🇧🇦" },
    { code: "BW", name: "Botswana", dialCode: "+267", flag: "🇧🇼" },
    { code: "BR", name: "Brazil", dialCode: "+55", flag: "🇧🇷" },
    { code: "IO", name: "British Indian Ocean Territory", dialCode: "+246", flag: "🇮🇴" },
    { code: "VG", name: "British Virgin Islands", dialCode: "+1284", flag: "🇻🇬" },
    { code: "BN", name: "Brunei", dialCode: "+673", flag: "🇧🇳" },
    { code: "BG", name: "Bulgaria", dialCode: "+359", flag: "🇧🇬" },
    { code: "BF", name: "Burkina Faso", dialCode: "+226", flag: "🇧🇫" },
    { code: "BI", name: "Burundi", dialCode: "+257", flag: "🇧🇮" },
    { code: "KH", name: "Cambodia", dialCode: "+855", flag: "🇰🇭" },
    { code: "CM", name: "Cameroon", dialCode: "+237", flag: "🇨🇲" },
    { code: "CA", name: "Canada", dialCode: "+1", flag: "🇨🇦" },
    { code: "CV", name: "Cape Verde", dialCode: "+238", flag: "🇨🇻" },
    { code: "KY", name: "Cayman Islands", dialCode: "+1345", flag: "🇰🇾" },
    { code: "CF", name: "Central African Republic", dialCode: "+236", flag: "🇨🇫" },
    { code: "TD", name: "Chad", dialCode: "+235", flag: "🇹🇩" },
    { code: "CL", name: "Chile", dialCode: "+56", flag: "🇨🇱" },
    { code: "CN", name: "China", dialCode: "+86", flag: "🇨🇳" },
    { code: "CX", name: "Christmas Island", dialCode: "+61", flag: "🇨🇽" },
    { code: "CC", name: "Cocos Islands", dialCode: "+61", flag: "🇨🇨" },
    { code: "CO", name: "Colombia", dialCode: "+57", flag: "🇨🇴" },
    { code: "KM", name: "Comoros", dialCode: "+269", flag: "🇰🇲" },
    { code: "CK", name: "Cook Islands", dialCode: "+682", flag: "🇨🇰" },
    { code: "CR", name: "Costa Rica", dialCode: "+506", flag: "🇨🇷" },
    { code: "HR", name: "Croatia", dialCode: "+385", flag: "🇭🇷" },
    { code: "CU", name: "Cuba", dialCode: "+53", flag: "🇨🇺" },
    { code: "CW", name: "Curaçao", dialCode: "+599", flag: "🇨🇼" },
    { code: "CY", name: "Cyprus", dialCode: "+357", flag: "🇨🇾" },
    { code: "CZ", name: "Czech Republic", dialCode: "+420", flag: "🇨🇿" },
    { code: "CD", name: "Democratic Republic of the Congo", dialCode: "+243", flag: "🇨🇩" },
    { code: "DK", name: "Denmark", dialCode: "+45", flag: "🇩🇰" },
    { code: "DJ", name: "Djibouti", dialCode: "+253", flag: "🇩🇯" },
    { code: "DM", name: "Dominica", dialCode: "+1767", flag: "🇩🇲" },
    { code: "DO", name: "Dominican Republic", dialCode: "+1809", flag: "🇩🇴" },
    { code: "EC", name: "Ecuador", dialCode: "+593", flag: "🇪🇨" },
    { code: "EG", name: "Egypt", dialCode: "+20", flag: "🇪🇬" },
    { code: "SV", name: "El Salvador", dialCode: "+503", flag: "🇸🇻" },
    { code: "GQ", name: "Equatorial Guinea", dialCode: "+240", flag: "🇬🇶" },
    { code: "ER", name: "Eritrea", dialCode: "+291", flag: "🇪🇷" },
    { code: "EE", name: "Estonia", dialCode: "+372", flag: "🇪🇪" },
    { code: "SZ", name: "Eswatini", dialCode: "+268", flag: "🇸🇿" },
    { code: "ET", name: "Ethiopia", dialCode: "+251", flag: "🇪🇹" },
    { code: "FK", name: "Falkland Islands", dialCode: "+500", flag: "🇫🇰" },
    { code: "FO", name: "Faroe Islands", dialCode: "+298", flag: "🇫🇴" },
    { code: "FJ", name: "Fiji", dialCode: "+679", flag: "🇫🇯" },
    { code: "FI", name: "Finland", dialCode: "+358", flag: "🇫🇮" },
    { code: "FR", name: "France", dialCode: "+33", flag: "🇫🇷" },
    { code: "GF", name: "French Guiana", dialCode: "+594", flag: "🇬🇫" },
    { code: "PF", name: "French Polynesia", dialCode: "+689", flag: "🇵🇫" },
    { code: "GA", name: "Gabon", dialCode: "+241", flag: "🇬🇦" },
    { code: "GM", name: "Gambia", dialCode: "+220", flag: "🇬🇲" },
    { code: "GE", name: "Georgia", dialCode: "+995", flag: "🇬🇪" },
    { code: "DE", name: "Germany", dialCode: "+49", flag: "🇩🇪" },
    { code: "GH", name: "Ghana", dialCode: "+233", flag: "🇬🇭" },
    { code: "GI", name: "Gibraltar", dialCode: "+350", flag: "🇬🇮" },
    { code: "GR", name: "Greece", dialCode: "+30", flag: "🇬🇷" },
    { code: "GL", name: "Greenland", dialCode: "+299", flag: "🇬🇱" },
    { code: "GD", name: "Grenada", dialCode: "+1473", flag: "🇬🇩" },
    { code: "GP", name: "Guadeloupe", dialCode: "+590", flag: "🇬🇵" },
    { code: "GU", name: "Guam", dialCode: "+1671", flag: "🇬🇺" },
    { code: "GT", name: "Guatemala", dialCode: "+502", flag: "🇬🇹" },
    { code: "GG", name: "Guernsey", dialCode: "+44", flag: "🇬🇬" },
    { code: "GN", name: "Guinea", dialCode: "+224", flag: "🇬🇳" },
    { code: "GW", name: "Guinea-Bissau", dialCode: "+245", flag: "🇬🇼" },
    { code: "GY", name: "Guyana", dialCode: "+592", flag: "🇬🇾" },
    { code: "HT", name: "Haiti", dialCode: "+509", flag: "🇭🇹" },
    { code: "HN", name: "Honduras", dialCode: "+504", flag: "🇭🇳" },
    { code: "HK", name: "Hong Kong", dialCode: "+852", flag: "🇭🇰" },
    { code: "HU", name: "Hungary", dialCode: "+36", flag: "🇭🇺" },
    { code: "IS", name: "Iceland", dialCode: "+354", flag: "🇮🇸" },
    { code: "IN", name: "India", dialCode: "+91", flag: "🇮🇳" },
    { code: "ID", name: "Indonesia", dialCode: "+62", flag: "🇮🇩" },
    { code: "IR", name: "Iran", dialCode: "+98", flag: "🇮🇷" },
    { code: "IQ", name: "Iraq", dialCode: "+964", flag: "🇮🇶" },
    { code: "IE", name: "Ireland", dialCode: "+353", flag: "🇮🇪" },
    { code: "IM", name: "Isle of Man", dialCode: "+44", flag: "🇮🇲" },
    { code: "IL", name: "Israel", dialCode: "+972", flag: "🇮🇱" },
    { code: "IT", name: "Italy", dialCode: "+39", flag: "🇮🇹" },
    { code: "CI", name: "Ivory Coast", dialCode: "+225", flag: "🇨🇮" },
    { code: "JM", name: "Jamaica", dialCode: "+1876", flag: "🇯🇲" },
    { code: "JP", name: "Japan", dialCode: "+81", flag: "🇯🇵" },
    { code: "JE", name: "Jersey", dialCode: "+44", flag: "🇯🇪" },
    { code: "JO", name: "Jordan", dialCode: "+962", flag: "🇯🇴" },
    { code: "KZ", name: "Kazakhstan", dialCode: "+7", flag: "🇰🇿" },
    { code: "KE", name: "Kenya", dialCode: "+254", flag: "🇰🇪" },
    { code: "KI", name: "Kiribati", dialCode: "+686", flag: "🇰🇮" },
    { code: "XK", name: "Kosovo", dialCode: "+383", flag: "🇽🇰" },
    { code: "KW", name: "Kuwait", dialCode: "+965", flag: "🇰🇼" },
    { code: "KG", name: "Kyrgyzstan", dialCode: "+996", flag: "🇰🇬" },
    { code: "LA", name: "Laos", dialCode: "+856", flag: "🇱🇦" },
    { code: "LV", name: "Latvia", dialCode: "+371", flag: "🇱🇻" },
    { code: "LB", name: "Lebanon", dialCode: "+961", flag: "🇱🇧" },
    { code: "LS", name: "Lesotho", dialCode: "+266", flag: "🇱🇸" },
    { code: "LR", name: "Liberia", dialCode: "+231", flag: "🇱🇷" },
    { code: "LY", name: "Libya", dialCode: "+218", flag: "🇱🇾" },
    { code: "LI", name: "Liechtenstein", dialCode: "+423", flag: "🇱🇮" },
    { code: "LT", name: "Lithuania", dialCode: "+370", flag: "🇱🇹" },
    { code: "LU", name: "Luxembourg", dialCode: "+352", flag: "🇱🇺" },
    { code: "MO", name: "Macau", dialCode: "+853", flag: "🇲🇴" },
    { code: "MG", name: "Madagascar", dialCode: "+261", flag: "🇲🇬" },
    { code: "MW", name: "Malawi", dialCode: "+265", flag: "🇲🇼" },
    { code: "MY", name: "Malaysia", dialCode: "+60", flag: "🇲🇾" },
    { code: "MV", name: "Maldives", dialCode: "+960", flag: "🇲🇻" },
    { code: "ML", name: "Mali", dialCode: "+223", flag: "🇲🇱" },
    { code: "MT", name: "Malta", dialCode: "+356", flag: "🇲🇹" },
    { code: "MH", name: "Marshall Islands", dialCode: "+692", flag: "🇲🇭" },
    { code: "MQ", name: "Martinique", dialCode: "+596", flag: "🇲🇶" },
    { code: "MR", name: "Mauritania", dialCode: "+222", flag: "🇲🇷" },
    { code: "MU", name: "Mauritius", dialCode: "+230", flag: "🇲🇺" },
    { code: "YT", name: "Mayotte", dialCode: "+262", flag: "🇾🇹" },
    { code: "MX", name: "Mexico", dialCode: "+52", flag: "🇲🇽" },
    { code: "FM", name: "Micronesia", dialCode: "+691", flag: "🇫🇲" },
    { code: "MD", name: "Moldova", dialCode: "+373", flag: "🇲🇩" },
    { code: "MC", name: "Monaco", dialCode: "+377", flag: "🇲🇨" },
    { code: "MN", name: "Mongolia", dialCode: "+976", flag: "🇲🇳" },
    { code: "ME", name: "Montenegro", dialCode: "+382", flag: "🇲🇪" },
    { code: "MS", name: "Montserrat", dialCode: "+1664", flag: "🇲🇸" },
    { code: "MA", name: "Morocco", dialCode: "+212", flag: "🇲🇦" },
    { code: "MZ", name: "Mozambique", dialCode: "+258", flag: "🇲🇿" },
    { code: "MM", name: "Myanmar", dialCode: "+95", flag: "🇲🇲" },
    { code: "NA", name: "Namibia", dialCode: "+264", flag: "🇳🇦" },
    { code: "NR", name: "Nauru", dialCode: "+674", flag: "🇳🇷" },
    { code: "NP", name: "Nepal", dialCode: "+977", flag: "🇳🇵" },
    { code: "NL", name: "Netherlands", dialCode: "+31", flag: "🇳🇱" },
    { code: "NC", name: "New Caledonia", dialCode: "+687", flag: "🇳🇨" },
    { code: "NZ", name: "New Zealand", dialCode: "+64", flag: "🇳🇿" },
    { code: "NI", name: "Nicaragua", dialCode: "+505", flag: "🇳🇮" },
    { code: "NE", name: "Niger", dialCode: "+227", flag: "🇳🇪" },
    { code: "NG", name: "Nigeria", dialCode: "+234", flag: "🇳🇬" },
    { code: "NU", name: "Niue", dialCode: "+683", flag: "🇳🇺" },
    { code: "NF", name: "Norfolk Island", dialCode: "+672", flag: "🇳🇫" },
    { code: "KP", name: "North Korea", dialCode: "+850", flag: "🇰🇵" },
    { code: "MK", name: "North Macedonia", dialCode: "+389", flag: "🇲🇰" },
    { code: "MP", name: "Northern Mariana Islands", dialCode: "+1670", flag: "🇲🇵" },
    { code: "NO", name: "Norway", dialCode: "+47", flag: "🇳🇴" },
    { code: "OM", name: "Oman", dialCode: "+968", flag: "🇴🇲" },
    { code: "PK", name: "Pakistan", dialCode: "+92", flag: "🇵🇰" },
    { code: "PW", name: "Palau", dialCode: "+680", flag: "🇵🇼" },
    { code: "PS", name: "Palestine", dialCode: "+970", flag: "🇵🇸" },
    { code: "PA", name: "Panama", dialCode: "+507", flag: "🇵🇦" },
    { code: "PG", name: "Papua New Guinea", dialCode: "+675", flag: "🇵🇬" },
    { code: "PY", name: "Paraguay", dialCode: "+595", flag: "🇵🇾" },
    { code: "PE", name: "Peru", dialCode: "+51", flag: "🇵🇪" },
    { code: "PH", name: "Philippines", dialCode: "+63", flag: "🇵🇭" },
    { code: "PN", name: "Pitcairn Islands", dialCode: "+64", flag: "🇵🇳" },
    { code: "PL", name: "Poland", dialCode: "+48", flag: "🇵🇱" },
    { code: "PT", name: "Portugal", dialCode: "+351", flag: "🇵🇹" },
    { code: "PR", name: "Puerto Rico", dialCode: "+1787", flag: "🇵🇷" },
    { code: "QA", name: "Qatar", dialCode: "+974", flag: "🇶🇦" },
    { code: "CG", name: "Republic of the Congo", dialCode: "+242", flag: "🇨🇬" },
    { code: "RE", name: "Réunion", dialCode: "+262", flag: "🇷🇪" },
    { code: "RO", name: "Romania", dialCode: "+40", flag: "🇷🇴" },
    { code: "RU", name: "Russia", dialCode: "+7", flag: "🇷🇺" },
    { code: "RW", name: "Rwanda", dialCode: "+250", flag: "🇷🇼" },
    { code: "BL", name: "Saint Barthélemy", dialCode: "+590", flag: "🇧🇱" },
    { code: "SH", name: "Saint Helena", dialCode: "+290", flag: "🇸🇭" },
    { code: "KN", name: "Saint Kitts and Nevis", dialCode: "+1869", flag: "🇰🇳" },
    { code: "LC", name: "Saint Lucia", dialCode: "+1758", flag: "🇱🇨" },
    { code: "MF", name: "Saint Martin", dialCode: "+590", flag: "🇲🇫" },
    { code: "PM", name: "Saint Pierre and Miquelon", dialCode: "+508", flag: "🇵🇲" },
    { code: "VC", name: "Saint Vincent and the Grenadines", dialCode: "+1784", flag: "🇻🇨" },
    { code: "WS", name: "Samoa", dialCode: "+685", flag: "🇼🇸" },
    { code: "SM", name: "San Marino", dialCode: "+378", flag: "🇸🇲" },
    { code: "ST", name: "São Tomé and Príncipe", dialCode: "+239", flag: "🇸🇹" },
    { code: "SA", name: "Saudi Arabia", dialCode: "+966", flag: "🇸🇦" },
    { code: "SN", name: "Senegal", dialCode: "+221", flag: "🇸🇳" },
    { code: "RS", name: "Serbia", dialCode: "+381", flag: "🇷🇸" },
    { code: "SC", name: "Seychelles", dialCode: "+248", flag: "🇸🇨" },
    { code: "SL", name: "Sierra Leone", dialCode: "+232", flag: "🇸🇱" },
    { code: "SG", name: "Singapore", dialCode: "+65", flag: "🇸🇬" },
    { code: "SX", name: "Sint Maarten", dialCode: "+1721", flag: "🇸🇽" },
    { code: "SK", name: "Slovakia", dialCode: "+421", flag: "🇸🇰" },
    { code: "SI", name: "Slovenia", dialCode: "+386", flag: "🇸🇮" },
    { code: "SB", name: "Solomon Islands", dialCode: "+677", flag: "🇸🇧" },
    { code: "SO", name: "Somalia", dialCode: "+252", flag: "🇸🇴" },
    { code: "ZA", name: "South Africa", dialCode: "+27", flag: "🇿🇦" },
    { code: "KR", name: "South Korea", dialCode: "+82", flag: "🇰🇷" },
    { code: "SS", name: "South Sudan", dialCode: "+211", flag: "🇸🇸" },
    { code: "ES", name: "Spain", dialCode: "+34", flag: "🇪🇸" },
    { code: "LK", name: "Sri Lanka", dialCode: "+94", flag: "🇱🇰" },
    { code: "SD", name: "Sudan", dialCode: "+249", flag: "🇸🇩" },
    { code: "SR", name: "Suriname", dialCode: "+597", flag: "🇸🇷" },
    { code: "SJ", name: "Svalbard and Jan Mayen", dialCode: "+47", flag: "🇸🇯" },
    { code: "SE", name: "Sweden", dialCode: "+46", flag: "🇸🇪" },
    { code: "CH", name: "Switzerland", dialCode: "+41", flag: "🇨🇭" },
    { code: "SY", name: "Syria", dialCode: "+963", flag: "🇸🇾" },
    { code: "TW", name: "Taiwan", dialCode: "+886", flag: "🇹🇼" },
    { code: "TJ", name: "Tajikistan", dialCode: "+992", flag: "🇹🇯" },
    { code: "TZ", name: "Tanzania", dialCode: "+255", flag: "🇹🇿" },
    { code: "TH", name: "Thailand", dialCode: "+66", flag: "🇹🇭" },
    { code: "TL", name: "Timor-Leste", dialCode: "+670", flag: "🇹🇱" },
    { code: "TG", name: "Togo", dialCode: "+228", flag: "🇹🇬" },
    { code: "TK", name: "Tokelau", dialCode: "+690", flag: "🇹🇰" },
    { code: "TO", name: "Tonga", dialCode: "+676", flag: "🇹🇴" },
    { code: "TT", name: "Trinidad and Tobago", dialCode: "+1868", flag: "🇹🇹" },
    { code: "TN", name: "Tunisia", dialCode: "+216", flag: "🇹🇳" },
    { code: "TR", name: "Turkey", dialCode: "+90", flag: "🇹🇷" },
    { code: "TM", name: "Turkmenistan", dialCode: "+993", flag: "🇹🇲" },
    { code: "TC", name: "Turks and Caicos Islands", dialCode: "+1649", flag: "🇹🇨" },
    { code: "TV", name: "Tuvalu", dialCode: "+688", flag: "🇹🇻" },
    { code: "VI", name: "U.S. Virgin Islands", dialCode: "+1340", flag: "🇻🇮" },
    { code: "UG", name: "Uganda", dialCode: "+256", flag: "🇺🇬" },
    { code: "UA", name: "Ukraine", dialCode: "+380", flag: "🇺🇦" },
    { code: "AE", name: "United Arab Emirates", dialCode: "+971", flag: "🇦🇪" },
    { code: "GB", name: "United Kingdom", dialCode: "+44", flag: "🇬🇧" },
    { code: "US", name: "United States", dialCode: "+1", flag: "🇺🇸" },
    { code: "UY", name: "Uruguay", dialCode: "+598", flag: "🇺🇾" },
    { code: "UZ", name: "Uzbekistan", dialCode: "+998", flag: "🇺🇿" },
    { code: "VU", name: "Vanuatu", dialCode: "+678", flag: "🇻🇺" },
    { code: "VA", name: "Vatican City", dialCode: "+379", flag: "🇻🇦" },
    { code: "VE", name: "Venezuela", dialCode: "+58", flag: "🇻🇪" },
    { code: "VN", name: "Vietnam", dialCode: "+84", flag: "🇻🇳" },
    { code: "WF", name: "Wallis and Futuna", dialCode: "+681", flag: "🇼🇫" },
    { code: "EH", name: "Western Sahara", dialCode: "+212", flag: "🇪🇭" },
    { code: "YE", name: "Yemen", dialCode: "+967", flag: "🇾🇪" },
    { code: "ZM", name: "Zambia", dialCode: "+260", flag: "🇿🇲" },
    { code: "ZW", name: "Zimbabwe", dialCode: "+263", flag: "🇿🇼" },
];
